$(() => {
  $('#rentals-communities-view-more').click(() => {
    $('#communities-modal').removeClass('hidden');
    $('body').css('overflow', 'hidden');
  });
});
